import { FC, useState } from "react"
import { IStudent } from "types"
import MainTable from "components/organisms/tables/MainTable"
import { useTableModel } from 'utils/tableModels/usePlopReportsTableModel'
import { Box, Button, Tooltip } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import { useGET_plopReportsQuery } from "redux/api/plopApi"
import DialogPopup from "components/molecules/DialogPopup"
import PlopReportForm from "components/organisms/forms/PlopReportForm"
import { useGET_learningStyleQuestionsQuery } from "redux/api/studentsApi"
import LearningStyleResult from "../student/LearningStyleResult"

interface IProps {
    student: IStudent
    tabText?: string
    tabKey?: string
}

const RtiPlopList: FC<IProps> = ({ student }) => {
    
    const { t } = useTranslation()

    const [plopOpen, setPlopOpen] = useState(false)
    
    const filters = {
        student: student.student_profile_id
    }

    const {
        data: learningStyle,
      } = useGET_learningStyleQuestionsQuery(student.student_profile_id, {skip: !student.student_profile_id})
    
    return <> 
        
        {student && student.student_profile_id && <>
        { learningStyle && learningStyle.is_taken && 
              <Box sx={{ marginBottom: '40px', background: '#fff' }} 
                className="thick-border"><LearningStyleResult data={learningStyle} reset_id={student.student_profile_id}/></Box> }

        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <Tooltip title={`${t('common.add-plop')}`} arrow placement='top'>
                <Button
                    variant='contained'
                    color='success'
                    aria-haspopup='true'
                    onClick={() => setPlopOpen(true)}
                    disableElevation
                    sx={{ 
                        lineHeight: '1rem'
                    }}
                >
                    <Add />                         
                    <span>{`${t('common.add-plop')}`}</span>
                </Button>
            </Tooltip>
        </div>

        <DialogPopup
              title={`PLOP - ${student.full_name}`}
              open={plopOpen}
              onClose={() => setPlopOpen(false)}
              popupWidth={'1400px'}
            >
              <PlopReportForm action={'add'} studentId={student.student_profile_id} onSuccess={() => {setPlopOpen(false)}} />
        </DialogPopup>

        <MainTable
            useTableModel={useTableModel}
            getTableData={useGET_plopReportsQuery}
            tableRowParams={ {'sid': student.id} }
            filters={filters}
        />    

        </>}
    </>
}
export default RtiPlopList